import {trigger, on} from './util/event'
import main from './util/main'
import isFunction from 'lodash/isFunction'



  var openStatEventName = 'open.kiosk.article.stat',
      closeStatEventName = 'close.kiosk.article.stat',

      openArticleEventName = 'open.kiosk.article',
      closeArticleEventName = 'close.kiosk.article',

      bookmarkEventName = 'bookmark.kiosk.article',
      shareEventName = 'share.kiosk.article',

      likeEventName = 'like.kiosk.article',
      dislikeEventName = 'dislike.kiosk.article',

      viewPaywallEventName = 'viewPaywall.kiosk.article',

      sessions = [],

      articleWasOpenedSource,
      stateInArticle = false,

      onOpenWithSource = [],
      onCloseWithSource = [],

      $paywall = $('body').find('.article-require-subscribe'),
      paywallTriggerPosition = $paywall.length ? ($paywall.offset().top - $(window).height() + $paywall.height() / 2) : null,
      prevScrollTop = $(window.document).scrollTop();



  $(window).on('load pjax:end', function(e) {
    const $body = $('body');
    if ($body.hasClass('a-article') || $body.hasClass('a-issue-article')) {
      const $article = $body.find('.article-container');
      stateInArticle = false;
      trigger(closeArticleEventName, {
        articleSourceId: articleWasOpenedSource
      }); // закрываем предыдущую, если будет переход снова на статью (другую)
      articleWasOpenedSource = $article.data('article-source-id');
      stateInArticle = true;
      trigger(openArticleEventName, {
        articleSourceId: articleWasOpenedSource
      });
    } else {
      stateInArticle = false;
      trigger(closeArticleEventName, {
        articleSourceId: articleWasOpenedSource
      });
    }

    $paywall = $body.find('.article-require-subscribe');
    paywallTriggerPosition = $paywall.length ? ($paywall.offset().top - $(window).height() + $paywall.height() / 2) : null
    prevScrollTop = $(window.document).scrollTop();

  });

  on(openArticleEventName, function(e) {
    const eventData       = e.detail,
        articleSourceId = eventData.articleSourceId;

    if (onOpenWithSource[articleSourceId] !== undefined && isFunction(onOpenWithSource[articleSourceId])) {
      onOpenWithSource[articleSourceId].call(undefined);
    }
  });

  on(closeArticleEventName, function(e) {
    var eventData       = e.detail,
        articleSourceId = eventData.articleSourceId;

    if (onCloseWithSource[articleSourceId] !== undefined && isFunction(onCloseWithSource[articleSourceId])) {
      onCloseWithSource[articleSourceId].call(undefined);
    }
  });



  on(openStatEventName, function(e) {

    const eventData = e.detail,
        uid = eventData.uid,
        id = eventData.id,
        type = eventData.type,
        issueId = eventData.issueId,
        pages = eventData.pages,
        url = eventData.url,
        closeUrl = eventData.closeUrl;

    $.ajax(url, {
      type: 'post',
      dataType: 'json',
      data: {
        id: id,
        issue_id: issueId
      },
      success: function (e) {
        if (e.session) {
          sessions[uid] = {
            id: id,
            uid: uid,
            start: +new Date(),
            session: e.session,
            closeUrl: closeUrl,
            issue_id: issueId,
            pages: pages,
            closed: false,
            listener: function (event) {
              trigger(closeStatEventName, {
                uid: uid
              });
            }
          };

          main.on('document:leave', sessions[uid].listener);
          // window.addEventListener("beforeunload", sessions[uid].listener);
        }

      }
    })

  });

  on(closeStatEventName, function(e) {

    var eventData = e.detail,
        uid       = eventData.uid,
        session   = sessions[uid];

    if (!session.closed) {

      $.ajax(session.closeUrl, {
        type: 'post',
        dataType: 'json',
        async: false,
        data: {
          id: session.id,
          session: session.session,
          spended_time: (+new Date() - session.start) / 1000,
          pages: session.pages,
          issue_id: session.issue_id
        },
        success: function(e) {
          sessions[uid].closed = true;
          main.off('document:leave', sessions[uid].listener);
          // window.removeEventListener('beforeunload', sessions[uid].listener, false);
        }
      });
    }
  });

  on(bookmarkEventName, function(e) {
    var  eventData = e.detail,
         id = eventData.id,
         url = eventData.url,
         $article = $('body').find('.article-container'),
         inFavorite = !!$article.data('in-favorite'),
         $btn = $article.find('.article-actions-bookmark button');

    $btn.prop('disabled', true);
    $.ajax({
      url: url,
      type: inFavorite ? 'DELETE' : 'PUT',
      success: function (data) {
        if (data.result) {
          $article.data('in-favorite', data.inFavorite);
          $btn[(data.inFavorite ? 'add' : 'remove') + 'Class']('custom-active');
        }
      },
      error: function () {
      },
      complete: function () {
        $btn.prop('disabled', false);
      }
    });

  });

  on(shareEventName, function(e) {
    var  eventData = e.detail,
        id = eventData.id,
        url = eventData.url;
      if(navigator.share){
        navigator.share({
          url: url
        })
      }
  });

on(likeEventName, function(e) {
  var  eventData = e.detail,
       id = eventData.id,
       url = eventData.url,
       $article = $('body').find('.article-item-wrapper[data-item-id="' + id + '"]'),
       like = parseInt($article.data('like')),
       $btnLike = $article.find('.btn-icon.like'),
       $btnDislike = $article.find('.btn-icon.dislike');

  $btnLike.prop('disabled', true);
  $btnDislike.prop('disabled', true);
  $.ajax({
    url: url,
    type: like === 1 ? 'DELETE' : 'PUT',
    success: function (data) {
      if (data.result) {
        $article.data('like', data.like);
        $btnLike[(data.like === 1 ? 'add' : 'remove') + 'Class']('custom-active');
        $btnDislike[(data.like === -1 ? 'add' : 'remove') + 'Class']('custom-active');
      }
    },
    error: function () {
    },
    complete: function () {
      $btnLike.prop('disabled', false);
      $btnDislike.prop('disabled', false);
    }
  });

})

on(dislikeEventName, function(e) {
  var  eventData = e.detail,
       id = eventData.id,
       url = eventData.url,
       $article = $('body').find('.article-item-wrapper[data-item-id="' + id + '"]'),
       like = parseInt($article.data('like')),
       $btnLike = $article.find('.btn-icon.like'),
       $btnDislike = $article.find('.btn-icon.dislike');

  $btnLike.prop('disabled', true);
  $btnDislike.prop('disabled', true);
  $.ajax({
    url: url,
    type: like === -1 ? 'DELETE' : 'PUT',
    success: function (data) {
      if (data.result) {
        $article.data('like', data.like);
        $btnLike[(data.like === 1 ? 'add' : 'remove') + 'Class']('custom-active');
        $btnDislike[(data.like === -1 ? 'add' : 'remove') + 'Class']('custom-active');
      }
    },
    error: function () {
    },
    complete: function () {
      $btnLike.prop('disabled', false);
      $btnDislike.prop('disabled', false);
    }
  });

});



main.on("document:scroll", function(scrollTop) {

var  $_paywall = $('body').find('.article-require-subscribe'),
    _paywallTriggerPosition = $_paywall.length ? ($_paywall.offset().top - $(window).height() + $_paywall.height() / 2) : null;

if (_paywallTriggerPosition !== paywallTriggerPosition) {
  paywallTriggerPosition = _paywallTriggerPosition;
}

  if (scrollTop >= paywallTriggerPosition && prevScrollTop < paywallTriggerPosition) {
    trigger(viewPaywallEventName, {});
  }

  prevScrollTop = scrollTop;

});


  const article = {
    openStat: openStatEventName,
    closeStat: closeStatEventName,

    initArticleOpenClose: function(sourceId, openCallback, closeCallback) {

      if (stateInArticle && articleWasOpenedSource == sourceId && onOpenWithSource[sourceId] === undefined && onCloseWithSource[sourceId] === undefined) {
        openCallback.call(undefined);
      }

      if (onOpenWithSource[sourceId] === undefined) {
        onOpenWithSource[sourceId] = openCallback;
      }
      if (onCloseWithSource[sourceId] === undefined) {
        onCloseWithSource[sourceId] = closeCallback;
      }

    },

    bookmarkEvent: bookmarkEventName,
    shareEvent: shareEventName,
    likeEvent: likeEventName,
    dislikeEvent: dislikeEventName,
    viewPaywallEvent: viewPaywallEventName,

  };

  export default article;
